<template>
  <div ref="chartEl" class="fe-star-trend-chart" :style="{ height: height }"></div>
</template>

<script>
import echarts from "echarts";

/**
 * 成长趋势折线图（Y 轴为展示星级 1~5，无分数）
 */
export default {
  name: "FeStarTrendChart",
  props: {
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    height: {
      type: String,
      default: "200px",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    items: {
      deep: true,
      handler: function () {
        this.renderChart();
      },
    },
  },
  mounted: function () {
    this.renderChart();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    /** 渲染星级折线图 */
    renderChart: function () {
      if (!this.$refs.chartEl) return;
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chartEl);
      }

      var list = this.items || [];
      var pointCount = list.length;
      var labels = list.map(function (i) {
        return i.Label || "";
      });
      var seriesData = list.map(function (i) {
        var val = null;
        if (i.DisplayStar != null && i.DisplayStar !== "") {
          var num = Number(i.DisplayStar);
          val = isNaN(num) ? null : num;
        }
        var isSnapshot = i.IsSnapshotPoint === true || i.isSnapshotPoint === true;
        return {
          value: val,
          symbol: isSnapshot ? "diamond" : "circle",
          symbolSize: isSnapshot ? 11 : 8,
          itemStyle: {
            color: isSnapshot ? "#f59e0b" : "#3b82f6",
            borderColor: "#fff",
            borderWidth: 2,
          },
        };
      });

      // 轮次少时加大两端留白，避免两点被拉到图表最左最右
      var boundaryGap = true;
      if (pointCount <= 1) {
        boundaryGap = [0.5, 0.5];
      } else if (pointCount <= 2) {
        boundaryGap = [0.42, 0.42];
      } else if (pointCount <= 4) {
        boundaryGap = [0.18, 0.18];
      }

      this.chart.setOption({
        grid: {
          left: 44,
          right: pointCount <= 2 ? 48 : 20,
          top: 28,
          bottom: pointCount > 4 ? 48 : 36,
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var p = params[0];
            if (!p) return "";
            var idx = p.dataIndex;
            var raw = list[idx] || {};
            var isSnapshot = raw.IsSnapshotPoint === true || raw.isSnapshotPoint === true;
            var val = p.value;
            var typeLabel = isSnapshot ? "轮次汇总" : "约德记录";
            return p.name + "（" + typeLabel + "）<br/>星级：" + (val == null ? "未评" : val + " 星");
          },
        },
        xAxis: {
          type: "category",
          data: labels,
          boundaryGap: boundaryGap,
          axisLabel: {
            fontSize: 11,
            color: "#64748b",
            rotate: pointCount > 4 ? 28 : 0,
            interval: 0,
            formatter: function (value) {
              if (!value) return "";
              // 快照点保持「第N轮汇总」
              if (value.indexOf("轮汇总") > 0) return value;
              // 点多时横轴只显示时分，完整日期时间在 tooltip
              if (pointCount > 3 && value.indexOf(" ") > 0) {
                return value.split(" ").pop();
              }
              return value;
            },
          },
          axisLine: { lineStyle: { color: "#e2e8f0" } },
        },
        yAxis: {
          type: "value",
          min: 1,
          max: 5,
          interval: 1,
          axisLabel: {
            formatter: "{value} 星",
            color: "#64748b",
            fontSize: 11,
          },
          splitLine: { lineStyle: { color: "#f1f5f9", type: "dashed" } },
        },
        series: [
          {
            type: "line",
            data: seriesData,
            smooth: true,
            connectNulls: false,
            lineStyle: { color: "#3b82f6", width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(59,130,246,0.18)" },
                  { offset: 1, color: "rgba(59,130,246,0.02)" },
                ],
              },
            },
          },
        ],
      }, true);
    },

    handleResize: function () {
      if (this.chart) this.chart.resize();
    },
  },
};
</script>

<style scoped>
.fe-star-trend-chart {
  width: 100%;
}
</style>
